import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "result", "value", "copy"]

  show() {
    const id = this.selectTarget.value
    this.resultTarget.classList.toggle("hidden", !id)
    this.valueTarget.textContent = id
    this.copyTarget.dataset.clipboardValue = id
  }
}
